import { render, staticRenderFns } from "./yiXinApplicationEdit.vue?vue&type=template&id=3d628974&scoped=true&"
import script from "./yiXinApplicationEdit.vue?vue&type=script&lang=js&"
export * from "./yiXinApplicationEdit.vue?vue&type=script&lang=js&"
import style0 from "./yiXinApplicationEdit.vue?vue&type=style&index=0&id=3d628974&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d628974",
  null
  
)

export default component.exports